import React, { useEffect } from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import App from 'App'
import { Error } from 'App/views'
import LoginCallback from 'App/views/LoginCallback/LoginCallback'

import { plurallClient } from 'utils'
import { ROUTES } from 'utils/constants'
import { getToken, Logout } from 'utils/token'

import { ResponsibleLinkStudentModalProvider } from '../hooks'

let environment = process.env.REACT_APP_NODE_ENV
if (environment === 'local') {
  environment = 'development'
}

if (environment === 'pull_request') {
  environment = 'staging'
}

async function initializePlurallTracker(timeout = 3000) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    const checkTracker = () => {
      if (window.PlurallTracker) {
        window.PLURALL_TRACKER = new window.PlurallTracker({
          clientId: 'account',
          environment,
          plurallFeedback: 6,
        })

        // @ts-ignore
        resolve()
      } else if (Date.now() - startTime > timeout) {
        reject(console.error('Timeout waiting for PlurallTracker to initialize'))
      } else {
        setTimeout(checkTracker, 100)
      }
    }

    checkTracker()
  })
}

initializePlurallTracker().catch(error => {
  console.error('Failed to initialize PlurallTracker:', error)
})

const Main = () => {
  useEffect(() => {
    const fetchData = async () => {
      try {
        window.PLURALL_TRACKER.pageView()
        const client = plurallClient()
        const user = await client.profile.get()
        if (!user) {
          Logout()
        }
      } catch (error) {
        console.error('Erro ao buscar perfil do usuário:', error)
      }
    }
    fetchData()
  }, [])

  return <App />
}

function PrivateRoute() {
  const auth = getToken()
  return auth ? <Outlet /> : Logout()
}
const AppRouters = () => (
  <ResponsibleLinkStudentModalProvider>
    <Routes>
      <Route element={<PrivateRoute />}>
        <Route path='/*' element={<Main />} />
      </Route>
      <Route path={ROUTES.LOGIN_CALLBACK} element={<LoginCallback />} />
      <Route path={ROUTES.ERROR} element={<Error />} />
    </Routes>
  </ResponsibleLinkStudentModalProvider>
)

export default AppRouters
